import { keyBy } from 'lodash';

export function updatePendingTasks(tasks, payload) {
  const dict = keyBy(tasks, 'task_id');
  const newTasks = keyBy(payload, 'task_id');

  return Object.values({ ...dict, ...newTasks });
}
